// extracted by mini-css-extract-plugin
export default {"FooterColumn":"Footer_FooterColumn__JOZCo","SectionHeader":"Footer_SectionHeader__TMCbD","ColumnFlex":"Footer_ColumnFlex__jpDDZ"};